import React, { useEffect, useState, useRef, useContext } from "react";
import useApp from "hooks/useApp";
import { Link } from "react-router-dom";
import { Switch, NoData, SelectList, Layer } from "components";
import bannerImg1 from "images/tmp_banner_image01.png";
import bannerImg2 from "images/tmp_banner_image02.png";
import bannerImg3 from "images/tmp_banner_image03.png";
import styles from "views/setting/index.module.css";
import layerStyles from "css/Layer.module.css";
import Lib from "library";
import axios from "axios";
import {
  showEventLayerState,
  moreEventPost,
  pushDataState,
} from "views/setting/states";
import { useRecoilState } from "recoil";
import Native from "library/native";

const EventContext = React.createContext();

const Event = ({ eventss }) => {
  const [showEventLayer, setShowEventLayer] =
    useRecoilState(showEventLayerState);
  const [morePage, setMorePage] = useRecoilState(moreEventPost);

  const App = useApp();
  const noMore = useRef(false);
  const isLoading = useRef(false);
  const layerWin = useRef();
  const page = useRef(1);

  const [events, setEvents] = useState(); // 이벤트 목록 데이터
  const [originalEvents, setOriginalEvents] = useState(); // 이벤트 목록 오리지날 데이터
  const [notiData, setNotiData] = useState(); // 알림 설정 데이터

  const [searchShow, setSearchShow] = useState(false); // 검색 목록 보이기 토글
  const [searchType, setSearchType] = useState(0); // 검색타입 value
  const [searchText, setSearchText] = useState("전체"); // 검색 조건 텍스트
  const [stusNm, setStusNm] = useState(); // 조건 파라미터

  const [showDetail, setShowDetail] = useState(false); // 이벤트 상세 레이어 보이기/가리기
  const [activeEventId, setActiveEventId] = useState(); // 클릭된 이벤트 아이디

  const [eventNotiYn, setEventNotiYn] = useState(); // 이벤트마케팅 알림
  const [alarmToggle, setAlarmToggle] = useState(false); // 이벤트 알람 토글

  const [rowsPerPage, setRowsPerPage] = useState(10); //페이지당 로우 수

  const [pushData, setPushData] = useRecoilState(pushDataState); // 푸쉬 데이터

  const SetEvent = (t) => {
    // 이벤트마케팅 저장
    setEventNotiYn(t);
  };

  const onEventClick = (id) => {
    console.log("event onClick event !!!!!");
    setActiveEventId(id);
    setShowDetail(true);
  };

  //정렬 항목 클릭했을 때
  const onSearchSelect = (key, value) => {
    setSearchType(value);
    setSearchText(key);
    if (value === 1) {
      setStusNm("ING");
    } else if (value === 2) {
      setStusNm("END");
    } else {
      setStusNm();
    }
  };

  useEffect(() => {
    noMore.current = false;
    setMorePage(1);
    getData(morePage);
  }, [stusNm]);

  useEffect(() => {
    // PUSH DATA 처리
    console.log("event pushData");
    console.log(pushData);
    if (pushData && pushData.url && showEventLayer) {
      const urlArr = pushData.url.split("/");
      if (urlArr[2] === "event") {
        if (pushData.no !== "") {
          // 상세조회인 경우,
          onEventClick(pushData.no);
        } else {
          // 상세조회가 아닌 경우,
          setPushData(null);
        }
      }
    }
  }, [pushData]);

  useEffect(() => {
    if (showEventLayer) {
      document.querySelector("nav .active")?.classList.remove("active");

      // PUSH DATA 처리
      if (pushData && pushData.url && showEventLayer) {
        const urlArr = pushData.url.split("/");
        if (urlArr[2] === "event") {
          if (pushData.no !== "") {
            // 상세조회인 경우,
            onEventClick(pushData.no);
          } else {
            // 상세조회가 아닌 경우,
            setPushData(null);
          }
        }
      }

      bindScroll();
      getData(morePage);
      getEvent();
      //정렬 값 초기화
      onSearchSelect("진행중", 1);
    } else if (showEventLayer === false) {
      setMorePage(1);
    }
  }, [showEventLayer]);

  //이벤트 리스트 데이터 가져오기
  const getData = (morePage) => {
    if (noMore.current) return;
    isLoading.current = true;
    if (typeof morePage !== "undefined") page.current = morePage;

    Lib.get(
      `/api/more/cstmr/srvc/event`,
      {
        rowsPerPage: rowsPerPage,
        pageNo: typeof morePage !== "undefined" ? morePage : page.current,
        stusNm: stusNm,
      },
      (data) => {
        //console.log('[EVENT목록] data : ' + JSON.stringify(data));
        isLoading.current = false;
        if (morePage > 1) {
          if (data.length < rowsPerPage) noMore.current = true;
          setEvents((prevState) => [...prevState, ...data]);
        } else {
          setEvents(data);
          if (data.length < rowsPerPage) noMore.current = true;
        }

        // if (!events) {
        // 	setEvents(data)
        // 	setOriginalEvents(data)
        // }
      }
    );
  };

  const bindScroll = () => {
    const layerWrap = layerWin.current.querySelector(`.${layerStyles.wrap}`);
    const wrapPadding = layerWin.current.querySelector(`#wrapPadding`);
    const screenHeight = window.screen
      ? window.screen.height
      : window.innerHeight;
    if (layerWrap) {
      layerWrap.addEventListener("scroll", (e) => {
        if (noMore.current) return;
        const scrollTop = layerWrap.scrollTop;
        const rect = wrapPadding.getBoundingClientRect();
        const top = rect.top;
        const height = rect.height;
        if (height + top - screenHeight <= scrollTop) {
          if (!isLoading.current) setMorePage((prevStus) => prevStus + 1);
        }
      });
      // if (!isLoading.current && !noMore.current) setMorePage(prevStus => prevStus + 1);
    }
  };

  useEffect(() => {
    getData(morePage);
  }, [morePage]);

  //이벤트 알림 설정 값 가져오기
  const getEvent = () => {
    Lib.post(`/api/more/noti/config`, (data) => {
      setNotiData(data);
      setEventNotiYn(data.eventNotiYn === "Y" ? true : false);
    });
  };

  //이벤트 알림 설정 값 없데이트
  const setEventAlarmConfig = () => {
    Lib.post(`/api/more/noti/config/upd`, {
      eventNotiYn: eventNotiYn === true ? "Y" : "N",
      estmtExprdTmNotiYn: notiData.estmtExprdTmNotiYn,
      crdtChgNotiYn: notiData.crdtChgNotiYn,
      cnsmpChgNotiYn: notiData.cnsmpChgNotiYn,
      assetChgNotiYn: notiData.assetChgNotiYn,
    });
  };

  //알림 on/off 바뀔때마다
  useEffect(() => {
    if (typeof eventNotiYn !== "undefined") {
      setEventAlarmConfig();
    }
  }, [eventNotiYn]);

  //레이어 닫은 후 실행
  const hidelayer = () => {
    setShowEventLayer(false);
  };

  return (
    <Layer
      show={showEventLayer}
      closeLayer={hidelayer}
      title="이벤트"
      ref={layerWin}
    >
      <div className="page">
        <div className="padding" id="wrapPadding">
          <div className={styles.title}>이벤트</div>

          <div className={`${styles["event-box"]} mt_30`}>
            <div>
              <p>새로운 이벤트 소식 알려드릴게요!</p>
              <span>이벤트 알림 받기 설정해주세요.</span>
            </div>
            <Switch on={eventNotiYn} onText="ON" onToggle={SetEvent}>
              OFF
            </Switch>
          </div>

          <div className="filter-group justify_between mt_40">
            <div>총 {events ? events.length : 0}건</div>
            <div onClick={() => setSearchShow(true)}>
              <span>{searchText}</span>
              <i className="icon icon_filter ml_5" />
            </div>
          </div>

          {/* 실제데이터 가져오기 */}
          <ul className={`${styles["event-list"]} mt_20`}>
            {events ? (
              <>
                {events.length ? (
                  <div>
                    {events.map((element, index) => {
                      let cn, text, endbg;
                      const start = Lib.ChanageNewDate(
                        `${element.operStDe.replace(/\.|-/g, "/")} ${
                          element.operStTm ? element.operStTm : "00:00:00"
                        }`
                      );
                      const end = Lib.ChanageNewDate(
                        `${element.operEdDe.replace(/\.|-/g, "/")} ${
                          element.operEdTm ? element.operEdTm : "23:59:59"
                        }`
                      );
                      const now = new Date();
                      if (start < now) {
                        if (end >= now) {
                          cn = "tag tag-blue-line tag-round";
                          endbg = "";
                          text = "진행중";
                        } else {
                          cn = "tag tag-gray-line tag-round";
                          endbg = "bg-gray";
                          text = "종료";
                        }
                        return (
                          <EventList
                            key={index}
                            element={element}
                            text={text}
                            className={cn}
                            className2={endbg}
                            onClick={(e) => onEventClick(element.sno)}
                          />
                        );
                      }
                    })}
                  </div>
                ) : (
                  <NoData text="등록된 이벤트가 없어요." />
                )}
              </>
            ) : (
              <NoData text="이벤트 정보를 조회중입니다." />
            )}
          </ul>
        </div>

        <SelectList
          data={[
            { key: "전체", value: 0 },
            { key: "진행중", value: 1 },
            { key: "종료", value: 2 },
          ]}
          show={searchShow}
          selected={searchType}
          onSelect={onSearchSelect}
          setShow={() => setSearchShow(false)}
          setText={setSearchText}
          title="정렬"
        />

        <EventContext.Provider
          value={{
            show: showDetail,
            closeLayer: setShowDetail,
            title: "이벤트",
            activeEventId,
          }}
        >
          <EventDetail />
        </EventContext.Provider>
      </div>
    </Layer>
  );
};
//이벤트 정렬 리스트
const EventList = ({ element, className, text, onClick, className2 }) => {
  return (
    <li onClick={onClick}>
      <div className={`img-box ${className2}`}>
        <img src={`/api/comm/showImage/${element.sstmFileId}`} alt="" />
      </div>
      <div className={`${styles["title-area"]} mt_10 mb_20`}>
        <div className="flex-align_center">
          <i className={className}>{text}</i>
          <p className="ellipsis ml_5">{element.operTitle}</p>
        </div>
        <span>{`${element.operStDe} ~  ${element.operEdDe}`}</span>
      </div>
    </li>
  );
};

//이벤트 상세화면
const EventDetail = () => {
  // PUSH
  const [pushData, setPushData] = useRecoilState(pushDataState); // 푸쉬 데이터
  const context = useContext(EventContext);
  const [data, setData] = useState();

  const getDetail = () => {
    Lib.get(`/api/more/cstmr/srvc/event/${context.activeEventId}`, (data) => {
      console.log("[EVENT상세] data : " + JSON.stringify(data));
      setData(data);
    });
  };

  useEffect(() => {
    if (context.show) {
      getDetail();

      if (pushData && pushData.url) {
        const urlArr = pushData.url.split("/");
        if (urlArr[2] === "event") {
          if (pushData.no !== "") {
            // 상세조회인 경우,
            setPushData(null);
          }
        }
      }
    }
    return () => setData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.show]);

  // 다운로드
  const downloadFile = async (fileId, fileNm) => {
    let ext = "";
    let mimeType = "";

    if (fileNm && fileNm.split(".").length > 0) {
      ext = fileNm.split(".")[1];
      mimeType = `application/${ext.toLowerCase()}`;
    }

    console.log("fileNm : " + fileNm);
    console.log("mimeType : " + mimeType);

    if (Native.getUserAgent() === "android") {
      Native.execute("AppManager", "downloadFile", undefined, {
        url:
          window.location.protocol +
          "//" +
          window.location.host +
          "/api/comm/download/" +
          fileId,
        filename: fileNm,
        mimeType: mimeType,
      });
    } else if (Native.getUserAgent() === "ios") {
      Native.execute("AppManager", "sharePlus", undefined, {
        type: "url",
        data:
          window.location.protocol +
          "//" +
          window.location.host +
          "/api/comm/download/" +
          fileId,
        filename: fileNm,
      });
    }

    // const options = {
    // 	method: "GET",
    // 	responseType: "arraybuffer",
    // 	headers: {},
    // 	data: {},
    // 	url: `/api/comm/download/${fileId}`,
    // 	maxContentLength: Infinity,
    // 	maxBodyLength: Infinity,
    // 	timeout: 60 * 30 * 1000,
    // 	cache: "no-cache"
    // };

    // await axios(options)
    // .then(function(response) {
    // 	console.log(response);
    // 	const url = window.URL.createObjectURL(
    // 		new Blob([response.data], {type: `${mimeType}`})
    // 	);
    // 	Lib.reqBlobFileDownlaod(url,fileNm);
    // 	setTimeout(() => {
    // 		window.URL.revokeObjectURL(url);
    // 	}, 1000);
    // })
    // .then(function() {
    // 	console.log("success");
    // })
    // .catch(function(error) {
    // 	console.log("fail");
    // });
  };

  return (
    <Layer {...context}>
      {data ? (
        <div className="page padding">
          <div className={styles["detail-title"]}>
            <p>{data.operTitle}</p>
            <span>{`${data.operStDe} ~ ${data.operEdDe}`}</span>
          </div>
          <hr className="my_30" />
          <div className={styles["detail-content"]}>
            <p
              className="section-cont"
              dangerouslySetInnerHTML={{ __html: data.operConts }}
            ></p>

            <div className="img-box mt_20">
              {/*	[이벤트상세에서 목록이미지 삭제. 20230128]
							{data.mainMultiAtchFileList &&
								data.mainMultiAtchFileList.length && data.mainMultiAtchFileList.map((item, index) => {
									return (
										<div key={index} className="img-box">
											<img src={`/api/comm/showImage/${item.sstmFileId}`} alt="" />
										</div>
									)
								})
							}
							*/}
              {data.dtlMultiAtchFileList &&
                data.dtlMultiAtchFileList.map((item, index) => {
                  return (
                    <div key={index} className="img-box">
                      <img
                        src={`/api/comm/showImage/${item.sstmFileId}`}
                        alt=""
                      />
                    </div>
                  );
                })}
            </div>

            <div className="img-box mt_20">
              {data.attachMultiAtchFileList &&
                data.attachMultiAtchFileList.map((item, index) => {
                  return (
                    <button
                      type="button"
                      className="btn"
                      onClick={() =>
                        downloadFile(item.sstmFileId, item.orignFileNm)
                      }
                    >
                      {`${item.orignFileNm} 파일 다운로드`}
                    </button>
                  );
                })}
              {/*
								data.attachMultiAtchFileList && 
								data.attachMultiAtchFileList.map((item, index) => {
									return (
										<div key={index} className="img-box">
											<img src={`/api/comm/showImage/${item.sstmFileId}`} alt="" />
										</div>
									)
								})
							*/}
            </div>
          </div>
        </div>
      ) : (
        <div className="page padding">
          <div
            className="skeleton"
            style={{ width: "20rem", height: "2rem" }}
          ></div>
          <div
            className="skeleton mt_10"
            style={{ width: "10rem", height: "2rem" }}
          ></div>
          <hr className="my_20" />
          <p className="skeleton" style={{ height: "15rem" }} />
          <p className="skeleton mt_20" style={{ height: "8rem" }} />
          <p className="skeleton mt_20" style={{ height: "8rem" }} />
        </div>
      )}
    </Layer>
  );
};

export default Event;
